import { endpoints } from "@/shared/api/endpoints";
import { httpClient } from "@/shared/api/httpClient";

export const statsAnalytics = async () => {
  const response = await httpClient.get(endpoints.totalAnalytics.stats);
  return response.data;
};


export const monthWiseAnalytics = async () => {
  const response = await httpClient.get(endpoints.totalAnalytics.monthWise);
  return response.data;
};

export const ageDistributionAnalytics = async () => {
  const response = await httpClient.get(endpoints.totalAnalytics.ageDistribution);
  return response.data;
};